class QuotesElement extends HTMLElement {
  constructor() {
    super();
    
    this.logos = this.querySelectorAll('.quotes__logo');
    this.panels = this.querySelectorAll('.quotes__item');

    this.logos.forEach((logo) => {
      logo.addEventListener('click', this.onLogoClick.bind(this));
    });
  }

  onLogoClick(event) {
    event.preventDefault();

    const button = event.target.closest('button');

    this.logos.forEach((logo) => {
      logo.setAttribute('aria-selected', 'false');
    });

    button.setAttribute('aria-selected', 'true');

    this.panels.forEach((panel) => {
      if (panel.id === `${button.getAttribute('aria-controls')}`) {
        panel.style.display = 'block';
      } else {
        panel.style.display = 'none';
      }
    });
  }
}

customElements.define('quotes-element', QuotesElement);
